/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ProductServoPipelineResultDto } from '../model/product-servo-pipeline-result-dto.model';
// @ts-ignore
import { PublicServoKaufpreisKaskoContractCreateDto } from '../model/public-servo-kaufpreis-kasko-contract-create-dto.model';
// @ts-ignore
import { ServoKaufpreisKaskoVersicherungspraemieCalcDto } from '../model/servo-kaufpreis-kasko-versicherungspraemie-calc-dto.model';
// @ts-ignore
import { VersicherungspraemieCalculationResultDto } from '../model/versicherungspraemie-calculation-result-dto.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PublicServoKaufpreisKaskoApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint post /api/public-servo-kaufpreis-kasko/contract/kaufpreiskasko
     * @param publicServoKaufpreisKaskoContractCreateDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicServoKaufpreisKaskoContractKaufpreiskaskoPost(publicServoKaufpreisKaskoContractCreateDto: PublicServoKaufpreisKaskoContractCreateDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProductServoPipelineResultDto>;
    public apiPublicServoKaufpreisKaskoContractKaufpreiskaskoPost(publicServoKaufpreisKaskoContractCreateDto: PublicServoKaufpreisKaskoContractCreateDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProductServoPipelineResultDto>>;
    public apiPublicServoKaufpreisKaskoContractKaufpreiskaskoPost(publicServoKaufpreisKaskoContractCreateDto: PublicServoKaufpreisKaskoContractCreateDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProductServoPipelineResultDto>>;
    public apiPublicServoKaufpreisKaskoContractKaufpreiskaskoPost(publicServoKaufpreisKaskoContractCreateDto: PublicServoKaufpreisKaskoContractCreateDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (publicServoKaufpreisKaskoContractCreateDto === null || publicServoKaufpreisKaskoContractCreateDto === undefined) {
            throw new Error('Required parameter publicServoKaufpreisKaskoContractCreateDto was null or undefined when calling apiPublicServoKaufpreisKaskoContractKaufpreiskaskoPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-servo-kaufpreis-kasko/contract/kaufpreiskasko`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProductServoPipelineResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: publicServoKaufpreisKaskoContractCreateDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/public-servo-kaufpreis-kasko/contract/kaufpreiskasko/versicherungspraemie
     * @param servoKaufpreisKaskoVersicherungspraemieCalcDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicServoKaufpreisKaskoContractKaufpreiskaskoVersicherungspraemiePost(servoKaufpreisKaskoVersicherungspraemieCalcDto: ServoKaufpreisKaskoVersicherungspraemieCalcDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VersicherungspraemieCalculationResultDto>;
    public apiPublicServoKaufpreisKaskoContractKaufpreiskaskoVersicherungspraemiePost(servoKaufpreisKaskoVersicherungspraemieCalcDto: ServoKaufpreisKaskoVersicherungspraemieCalcDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VersicherungspraemieCalculationResultDto>>;
    public apiPublicServoKaufpreisKaskoContractKaufpreiskaskoVersicherungspraemiePost(servoKaufpreisKaskoVersicherungspraemieCalcDto: ServoKaufpreisKaskoVersicherungspraemieCalcDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VersicherungspraemieCalculationResultDto>>;
    public apiPublicServoKaufpreisKaskoContractKaufpreiskaskoVersicherungspraemiePost(servoKaufpreisKaskoVersicherungspraemieCalcDto: ServoKaufpreisKaskoVersicherungspraemieCalcDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (servoKaufpreisKaskoVersicherungspraemieCalcDto === null || servoKaufpreisKaskoVersicherungspraemieCalcDto === undefined) {
            throw new Error('Required parameter servoKaufpreisKaskoVersicherungspraemieCalcDto was null or undefined when calling apiPublicServoKaufpreisKaskoContractKaufpreiskaskoVersicherungspraemiePost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-servo-kaufpreis-kasko/contract/kaufpreiskasko/versicherungspraemie`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VersicherungspraemieCalculationResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servoKaufpreisKaskoVersicherungspraemieCalcDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
